var _circle, _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPremium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 129 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64.5,
    cy: 64.5,
    r: 64.5,
    fill: "url(#a)",
    fillOpacity: 0.7
  })), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 40,
    width: 76,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.5 40h-75v50h75V40Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.5 42c3.375 0 6.375 1.969 7.875 4.875a8.916 8.916 0 0 1 9.094 2.156 8.916 8.916 0 0 1 2.156 9.094c2.906 1.5 4.875 4.5 4.875 7.875 0 3.469-1.969 6.469-4.875 7.969 1.031 3.094.281 6.562-2.156 9-2.438 2.437-6 3.187-9.094 2.25A8.831 8.831 0 0 1 65.5 90c-3.469 0-6.469-1.875-7.969-4.781a8.998 8.998 0 0 1-9-2.25 8.998 8.998 0 0 1-2.25-9c-2.906-1.5-4.781-4.5-4.781-7.969a8.831 8.831 0 0 1 4.781-7.875c-.937-3.094-.187-6.656 2.25-9.094 2.438-2.437 5.907-3.187 9-2.156 1.5-2.906 4.5-4.875 7.969-4.875Zm10.594 19.594a2.207 2.207 0 0 0 0-3.094c-.938-.938-2.344-.938-3.188 0L62.5 68.906 58.094 64.5c-.938-.938-2.344-.938-3.188 0a2.053 2.053 0 0 0 0 3.094l6 6c.844.937 2.25.937 3.188 0l12-12Z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.03 68.618 1.12 2.905 2.854 1.07c.255.05.408.305.408.56 0 .204-.153.459-.408.51l-2.853 1.12-1.121 2.854c-.051.254-.306.407-.51.407-.255 0-.51-.153-.56-.407l-1.07-2.853-2.904-1.122c-.204-.05-.357-.305-.357-.509 0-.255.153-.51.356-.56l2.905-1.07 1.07-2.905c.05-.254.305-.356.56-.356.204 0 .459.102.51.356ZM85.848 84.76l.623 1.614 1.585.595c.142.028.227.17.227.31 0 .114-.085.256-.227.284l-1.585.623-.623 1.585c-.028.141-.17.226-.283.226-.141 0-.283-.085-.311-.226l-.595-1.585-1.613-.623c-.113-.028-.198-.17-.198-.283 0-.142.085-.283.198-.311l1.613-.595.595-1.613c.028-.142.17-.198.311-.198.113 0 .255.056.283.198ZM33.3 40.317l.997 2.582 2.536.95c.227.046.363.272.363.499 0 .181-.136.407-.363.453l-2.536.996-.996 2.536c-.046.227-.272.363-.453.363-.227 0-.453-.136-.498-.363l-.951-2.536-2.582-.996c-.181-.046-.317-.272-.317-.453 0-.227.136-.453.317-.498l2.582-.951.95-2.582c.046-.226.272-.317.499-.317.181 0 .407.09.453.317Z",
    fill: "#719CF9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(90 -5.137 70.208) scale(53.6549)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3EA2A",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C8418",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 89.5,
    y1: 72,
    x2: 43.493,
    y2: 71.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#A3EA2A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremium);
export default __webpack_public_path__ + "static/media/premium.eb86c025a74b64f0979c9781d3abf1f3.svg";
export { ForwardRef as ReactComponent };